module.exports = __webpack_public_path__ + "static/media/079-egypt.16f03f44.svg";